export default __webpack_public_path__ + "static/media/mPants_1_p4.44f33d76.jpeg";